module.exports = __webpack_public_path__ + "fonts/KaTeX_Main-BoldItalic.5f875f98.woff";